import { Stack } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";
import { useState } from "react";
import BackPageButton from "components/buttons/BackPageButton";
import ROUTES from "constants/routes";
import Header from "./components/Header";
import Content from "./components/Content";
import CandidatesList from "./components/CandidateList";
import { VacancyCompanyCandidatesRefetch } from "./types";

const CandidateView = () => {
  const isCreate = useIsCreate();
  const [vacancyCompanyCandidatesRefetch, setVacancyCompanyCandidatesRefetch] =
    useState<VacancyCompanyCandidatesRefetch | null>(null);

  return (
    <>
      <BackPageButton
        defaultValue={{
          text: "Список вакансий",
          link: `/${ROUTES.VACANCIES}`,
        }}
      />
      <Stack spacing={2.5}>
        <Header />
        <Content vacancyCompanyCandidatesRefetch={vacancyCompanyCandidatesRefetch} />
        {!isCreate && <CandidatesList setVacancyCompanyCandidatesRefetch={setVacancyCompanyCandidatesRefetch} />}
      </Stack>
    </>
  );
};

export default CandidateView;
